import type { AreaSelectListExEntity } from '@/libs/api'

export const mapToAreaFieldName = (area: AreaSelectListExEntity) => {
  return `${area.code}/${area.name}`
}
